// extracted by mini-css-extract-plugin
export default {"ContainerRes":"Result_ContainerRes__lsOD+"};